import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Testimonial as TestimonialComponent } from "../../sharedComponents/Testimonial";
import * as styles from "./Testimonial.module.scss";

const defaultClassNames = {
	heading: styles.testimonialHeading,
	quoteContainer: styles.testimonialQuoteContainer,
	image: styles.testimonialImage,
	textContent: styles.testimonialTextContent,
	source: styles.testimonialSource,
};

const Testimonial = ({
	className,
	classNames: providedClassNames,
	displayTitle,
	image,
	quote,
	source,
	date,
	branding,
}) => {
	const classNames = { ...defaultClassNames, ...providedClassNames };

	const classes = cx(styles.testimonial, {
		[branding === "default" ? styles.defaultStyle : styles[branding]]: branding,
		[className]: className,
	});
	return (
		<TestimonialComponent
			className={classes}
			classNames={classNames}
			displayTitle={displayTitle}
			quote={quote}
			source={source}
			date={date}
			styles={styles}
			image={image}
			branding={branding}
		/>
	);
};

Testimonial.propTypes = {
	className: PropTypes.string,
	classNames: PropTypes.shape({
		heading: PropTypes.string,
		quoteContainer: PropTypes.string,
		image: PropTypes.string,
		textContent: PropTypes.string,
		source: PropTypes.string,
	}),
	displayTitle: PropTypes.string,
	image: PropTypes.shape({
		alt: PropTypes.string,
		fluid: PropTypes.object,
		title: PropTypes.string,
	}),
	quote: PropTypes.string,
	source: PropTypes.string,
	date: PropTypes.string,
	branding: PropTypes.oneOf(["weddings", "sunwing", "default"]),
};
Testimonial.defaultProps = {
	className: undefined,
	classNames: defaultClassNames,
	displayTitle: undefined,
	image: undefined,
	quote: undefined,
	source: undefined,
	date: undefined,
	branding: undefined,
};

export default Testimonial;
export { Testimonial };
